import { Sort } from "@models/index";

export const TOP_TRENDS_CATEGORIES = [
    {
        id: 1,
        name: 'Sauce/Flavor',
        image: '/Sauce.jpg',
    },
    {
        id: 2,
        name: 'Spice',
        image: '/Spice.jpeg',
    },
    {
        id: 3,
        name: 'Protein',
        image: '/Protein.jpeg',
    },
    {
        id: 6,
        name: 'Veggie',
        image: '/Veggie.jpeg',
    },
    {
        id: 7,
        name: 'Fruit',
        image: '/Fruit.jpeg',
    },
    {
        id: 5,
        name: 'Cheese',
        image: '/Cheese.jpeg',
    },
    {
        id: 4,
        name: 'Bread',
        image: '/Bread.jpeg',
    },
    {
        id: 9,
        name: 'Noodle',
        image: '/Noodle.jpeg',
    },
    {
        id: 8,
        name: 'Nut',
        image: '/Nut.jpeg',
    },
    {
        id: 10,
        name: 'Appetizer',
        image: '/Appetizer.jpg',
    },
    {
        id: 11,
        name: 'Entree',
        image: '/Entree.jpeg',
    },
    {
        id: 12,
        name: 'Side',
        image: '/Side.jpeg',
    },
    {
        id: 13,
        name: 'Dessert',
        image: '/Dessert.jpg',
    },
    {
        id: 14,
        name: 'Non Alc Bev',
        image: '/Non Alc Bev.jpg',
    },
    {
        id: 15,
        name: 'Cocktail',
        image: '/Cocktail.jpeg',
    },
    {
        id: 16,
        name: 'Alcohol Type',
        image: '/Alcohol Type.jpeg',
    },
    {
        id: 18,
        name: 'Prep Method',
        image: '/Prep Method.jpeg',
    },
    {
        id: 19,
        name: 'Healthy',
        image: '/Healthy.jpeg',
    },
    {
        id: 20,
        name: 'Descriptor',
        image: '/Descriptor.jpeg',
    },
    {
        id: 21,
        name: 'Brand',
        image: '/Brand.jpeg',
    },
    {
        id: 22,
        name: 'Location',
        image: '/Location.jpeg',
    }
];

export enum TopTrendsSortingColumnsEnum {
    Penetration = 0,
    Incidence = 1,
    PenetrationCT = 2,
    MenuItemCount = 3,
    PastGrowth = 4,
    CAGR = 5,
    KnowIt = 6,
    HaveTriedIt = 7,
    LoveOrLikeIt = 8,
}

export function getTopTrendsSortingColumnName(column: TopTrendsSortingColumnsEnum) {
    switch (column) {
        case TopTrendsSortingColumnsEnum.Penetration:
            return "Penetration";
        case TopTrendsSortingColumnsEnum.Incidence:
            return "Incidence";
        case TopTrendsSortingColumnsEnum.PenetrationCT:
            return "Penetration CT";
        case TopTrendsSortingColumnsEnum.PastGrowth:
            return "Past Growth";
        case TopTrendsSortingColumnsEnum.CAGR:
            return "CAGR";
        case TopTrendsSortingColumnsEnum.KnowIt:
            return "Know It";
        case TopTrendsSortingColumnsEnum.HaveTriedIt:
            return "Have Tried It";
        case TopTrendsSortingColumnsEnum.LoveOrLikeIt:
            return "Love or Like It";
        default:
            return "";
    }
}

export function getTopTrendsApiSortingDirection(num?: 0 | 1): Sort {
    return num === 0 ? Sort.Asc : Sort.Desc;
}

export function getTopTrendsApiSortingDirectionNum(sort: Sort | null): 0 | 1 {
    return sort === Sort.Asc ? 0 : 1;
}